import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthCallback } from '@acp/feature/auth';

interface AuthCallbackProps {
    /**
     * Element to show while were loading
     */
    loadingElement: JSX.Element;
}

/**
 * Gets the state, loginType and loginSelect from the URL
 */
export function AuthCallback({
    loadingElement,
}: AuthCallbackProps) {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useAuthCallback(
        searchParams.get('token'),
        searchParams.get('state'),
        searchParams.get('__acp_impersonating') === '1',
        searchParams.get('__acp_compliance_session_id'),
        searchParams.get('__acp_original_user_id'),
        searchParams.get('__acp_original_user_sig'),
        searchParams.get('login_id_username') === '1',
        {
            onSuccess: (state) => {
                if (state === null) {
                    navigate('/', {
                        replace: true,
                    });
                    return;
                }

                navigate(state, {
                    replace: true,
                });
            },
            onFailure: () => {
                navigate('/auth/error?message=Failed to login', {
                    replace: true,
                });
            },
        }
    );

    return loadingElement;
}
